import { render, staticRenderFns } from "./pointOld.vue?vue&type=template&id=2a6ab4a2&scoped=true&"
import script from "./pointOld.vue?vue&type=script&lang=js&"
export * from "./pointOld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ab4a2",
  null
  
)

export default component.exports